module.exports = __webpack_public_path__ + "img/user-icon.268f42c2.svg";